import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyles = createUseStyles(({ brandColors, breakpoints, type }: CmsWrenchTheme) => {
  const mediaMinMD = `@media (min-width: ${breakpoints.md}px)`;
  const flexCenter = { display: 'flex', justifyContent: 'center', alignItems: 'center' };
  const commonCardBorder = { border: `2px solid ${brandColors.neutral.offWhite}`, borderRadius: '20px' };

  return {
    mainSection: {
      ...flexCenter,
      flexDirection: 'column',
      maxWidth: '965px',
      margin: '0 auto',
      gap: '24px',
    },

    headerSection: {
      '& h1': {
        fontSize: type.fontSize.cardTitle,
        padding: '0 16px',
        [mediaMinMD]: { fontSize: type.fontSize.sectionTitle, padding: '0' },
      },
    },
    templateCardContainer: {
      ...flexCenter,
      flexDirection: 'column',
      flexWrap: 'wrap',
      gap: '24px',
      width: '100%',
      margin: '0 auto',
      [mediaMinMD]: { flexDirection: 'row' },
    },
    viewAllCTAContainer: {
      width: '90%',
      backgroundColor: brandColors.neutral.white,
      ...flexCenter,
      padding: '32px',
      borderRadius: '20px',
      border: `2px solid ${brandColors.neutral.offWhite}`,
      marginBottom: '32px',
      [mediaMinMD]: { width: '100%' },
    },
    templateCard: {
      width: '304px',
      maxHeight: '415px',
      display: 'flex',
      flexDirection: 'column',
      ...commonCardBorder,
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      padding: '20px',
      '& section': {
        width: '100%',
        height: '130px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      },
      '& p': {
        fontSize: type.fontSize.body,
        lineHeight: '20px',
      },
    },
    pathImage: {
      width: '100%',
      height: '182px',
      objectFit: 'cover',
      borderRadius: '18px 18px 0 0',
    },
    viewAllCTA: {
      fontSize: type.fontSize.body,
      color: brandColors.primary.info,
      textDecoration: 'underline',
      '& span': { marginLeft: '8px', color: brandColors.primary.info },
    },
  };
});

export default useStyles;
